/**
 * NaturopathicConsent Component
 *
 * Informed Consent to Naturopathic Treatment form
 * Covers natural therapies, modalities, risks, and treatment authorization
 */

import React from "react";
import { Typography, Button, Card, CardContent } from "@material-ui/core";
import SignatureCanvas from "react-signature-canvas";

function NaturopathicConsent({
  checked,
  onChange,
  answers,
  signatureRef,
  onClearSignature,
  readOnly,
  version,
}) {
  if (!checked) {
    return null;
  }

  return (
    <div>
      {readOnly && version && (
        <Card style={{ marginBottom: 16, backgroundColor: "#fffacd" }}>
          <CardContent>
            <Typography variant="body2" style={{ color: "#856404" }}>
              <b>Historical View:</b> This form was submitted on{" "}
              {version.submittedAt?.split("T")[0]} under consent version{" "}
              {version.versionId} and is displayed for reference only.
            </Typography>
          </CardContent>
        </Card>
      )}

      <Typography variant="h4" style={{ textAlign: "left" }}>
        Informed Consent to Naturopathic Treatment
      </Typography>
      <br />
      <Typography variant="body1" style={{ textAlign: "left" }}>
        Naturopathic medicine is a form of health care that utilizes natural
        therapies and modalities to promote wellness and treat various health
        conditions. It encompasses a range of modalities, including but not
        limited to nutritional and lifestyle modifications, counselling, herbal
        medicine, supplementation, Traditional Chinese Medicine, homeopathy, and
        physical medicine. As a patient, you will be provided with information
        regarding your diagnosis, treatment options, and alternative approaches.
        You will also be informed about the material effects, anticipated
        benefits, risks, side effects, and potential outcomes.
        <br />
        <br />
        I understand that:
        <br />
        <ul>
          <li>
            Any treatment or advice provided to the clinic as a patient of Dr.
            Naturopathic, ND is not mutually exclusive of any treatment that I
            may now be receiving or may in the future receive from another
            licensed health care provider.{" "}
          </li>
          <li>
            I am at liberty to seek or continue medical care from a physician or
            other health care provider licensed to practice in Ontario.{" "}
          </li>
          <li>
            The treatments and therapies provided or recommended by Dr.
            Naturopathic, ND may differ from those typically offered by a
            medical doctor or other licensed healthcare professional.{" "}
          </li>
          <li>
            My Dr. Naturopathic, ND does not guarantee treatment results.{" "}
          </li>
          <li>
            free to withdraw my consent and to discontinue treatment at any
            time.{" "}
          </li>
          <li>
            {" "}
            There are some risks associated with naturopathic therapies. Dr.
            Naturopathic, ND will explain risks associated with the treatment
            with you when these exist. They include, but are not limited to:
            <ul>
              <li>Aggravation of pre-existing symptoms </li>
              <li>Allergic reaction to supplements or herbs </li>
              <li>
                Pain, bruising or injury from blood tests, acupuncture or B12
                injections{" "}
              </li>
              <li>Fainting or puncturing with acupuncture needles </li>
              <li>
                Naturopathic treatment or testing is not covered by OHIP. I am
                solely responsible for payment at the time of each visit or
                treatment.{" "}
              </li>
            </ul>
          </li>
        </ul>
        <br />
        I declare that I have received a full and complete explanation of the
        treatment or services that I may receive from Dr. Naturopathic, ND, and
        hereby authorize and consent to treatment by Dr. Naturopathic, ND.
        <br />
        <br />I also confirm that I have the ability to accept or reject this
        care of my own free will and choice and that I am not an agent of any
        private, local, county, provincial or federal agency attempting to
        gather information without so stating. I accept full responsibility for
        any fees incurred during care and treatment.
      </Typography>
      <br />
      <br />
      <Typography variant="body1" style={{ textAlign: "left" }}>
        Please sign in the box below.
      </Typography>
      <div
        style={{
          borderStyle: "dotted",
          borderWidth: 2,
          borderColor: "#D3D3D3",
          width: 530,
          height: 240,
          borderRadius: 4,
        }}
      >
        <SignatureCanvas
          penColor="black"
          ref={signatureRef}
          canvasProps={{
            width: 530,
            height: 240,
            className: "consentNaturopathicSig",
          }}
          disabled={readOnly}
        />
      </div>
      <br />
      {!readOnly && <Button onClick={onClearSignature}>Clear</Button>}
      <br />
      <br />
    </div>
  );
}

export default NaturopathicConsent;
